import { Constants } from '@leverege/molten'

import StationsRouteCreator from './StationsRouteCreator'

export default {
  install( molten ) {
    molten.addPlugin( Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, StationsRouteCreator )
  }
}
